import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { userService, type UserSettings } from '../services/user.service';

export function useUserSettings(userFronteggId: string, options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<UserSettings>({
    queryKey: ['userSettings', userFronteggId],
    queryFn: () => userService.getUserSettings(userFronteggId),
    enabled: enabled && !!userFronteggId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateUserSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      userFronteggId,
      settings,
    }: {
      userFronteggId: string;
      settings: Partial<Omit<UserSettings, 'id' | 'frontegg_id'>>;
    }) => userService.updateUserSettings(userFronteggId, settings),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['userSettings', variables.userFronteggId],
      });
      if ('group_id' in variables.settings) {
        queryClient.invalidateQueries({ queryKey: ['userGroupMemberships'] });
        queryClient.invalidateQueries({ queryKey: ['userGroups'] });
      }
    },
  });
}
